import { el } from 'redom';

import { stringToSVG } from 'utilities';

import './index.scss';

import addIconString from 'assets/images/add-icon.svg?raw';

const addIcon = stringToSVG(addIconString);

class AddActionLabelView {

  constructor(configuration) {

    this.el = el('.add-action-label', [
      addIcon.cloneNode(true),
      el('label', configuration.label)
    ]);

  }

}

export default AddActionLabelView;